import React from "react";
import { connect } from "react-redux";

import FamilyDetail from "./FamilyDetail";
import getMyUserFamilyProfile from "../../../../../_selectors/userSelectors/getMyUserFamilyProfile";
const Family = ({ userProfile, update, showToast }) => {
  return (
    <FamilyDetail
      userProfile={userProfile}
      update={update}
      toast={showToast}
      showEdit={true}
    />
  );
};
const mapStateToProps = (state, ownProps) => ({
  userProfile: getMyUserFamilyProfile(state)
});

export default connect(mapStateToProps)(Family);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Family/index.js